module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<table>\n	<tr>\n		<th>Machine device</th>\n		<td>\n			'+
((__t=(APP.UI.chooser("d_id", "devices", d_id,'single',{protocol:'machine'})))==null?'':__t)+
'\n		</td>\n	</tr>\n</table>\n';
}
return __p;
};
